import { render } from "./SearchComponent.vue?vue&type=template&id=06fc41c4&ts=true"
import script from "./SearchComponent.vue?vue&type=script&lang=ts"
export * from "./SearchComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__